<template>
    <b-form-group
        :id="formGroupId"
        :label-for="selectId"
        class="base-filter-select filter-input-group mx-1"
        :class="{'filter-applied': value !== resetValue }"
    >
        <template #label>
            <div class="d-flex justify-content-between align-items-baseline">
                <div>{{ label }}</div>
                <b-link
                    v-if="value !== resetValue" 
                    @click="handleReset"
                    class="text-decoration-none ml-2"
                >Clear</b-link>
            </div>
        </template>
        <b-form-select 
            :id="selectId"
            :value="value"
            @input="onInput" 
            :options="options"
            :value-field="valueField"
            :text-field="textField"
            class="w-100"
            @change="onChange"
        >
            <template #first>
                <b-form-select-option 
                    v-if="firstOptionText"
                    :value="resetValue"
                >
                    {{ firstOptionText }}
                </b-form-select-option>
            </template>
        </b-form-select>
    </b-form-group>
</template>

<script>
import kebabCase from 'lodash/kebabCase';
import uniqueId from 'lodash/uniqueId';

export default {
    name: 'BaseFilterSelect',
    components: {},
    props: {
        value: {  // the v-model
            required: true,
        },
        resetValue: {  // when you hit clear/reset, value goes to this
            type: [String, Number],
            default: '',
        },
        firstOptionText: {  // IF PROVIDED, the VALUE for this option is the resetValue
            type: String,
            required: false,
        },
        options: {},  // this goes straight to :options of select box -- should be ARRAY but we won't specify type otherwise error will throw while things are loading and undefined is passed in
        label: {
            type: String,
            required: false,
        },
        valueField: {
            type: String,
            default: 'value',
        },
        textField: {
            type: String,
            default: 'text',
        }
    },
    data: function() {
        return {

        }
    },
    computed: {
        idString: function() {
            // make an ID from the label, otherwise set to uniqueId
            return this.label ? kebabCase(this.label) : uniqueId.toString();
        },
        formGroupId: function() {
            return 'fieldset-filter-' + this.idString;
        },
        selectId: function() {
            return 'select-filter-' + this.idString;
        }
    },
    methods: {
        onChange: function(value) {
            // pass up the 'change' event -- this happens only on user-initiated changes
            this.$emit('change', value);
        },
        onInput: function(value) {
            // pass up the value, this is needed to support v-model
            this.$emit('input', value);
        },
        handleReset: function() {
            this.onInput(this.resetValue);  // call this to handle v-model ?
            this.onChange(this.resetValue);  // call this to make parent aware of change
        }
    }
}
</script>

<style>

</style>